 <template>
  <div class="progressDetailPage _boxBg_dark absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">{{measureName}}碳中和实时进展</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="_dark_icon">年度变化</div>
      <ul>
        <li>
          <div class="li_left">实施期</div>
          <div class="li_right">
            {{getDate(dataList.planStartTime)}}~{{getDate(dataList.planEndTime)}}
          </div>
        </li>
        <li>
          <div class="li_left">降碳</div>
          <div class="li_right">
            <span>{{dataList.planEmissions}}</span> {{dataList.unit}}
          </div>
        </li>
        <li>
          <div class="li_left">投资金额</div>
          <div class="li_right">
            <span>{{dataList.investmentAmount}}</span> 万元
          </div>
        </li>
        <li>
          <div class="li_left">减污</div>
          <div class="li_right">
            <span>{{dataList.planPollutantEmissions}}</span> {{dataList.pollutantUnit}}
          </div>
        </li>

      </ul>
      <div class="_dark_icon">主要建设内容</div>
      <div class="text_box">
        <p>
          {{dataList.mainBuildContent}}
        </p>
      </div>
      <div class="_dark_icon">减污降碳效果</div>
      <div class="text_box">
        <p>
          {{dataList.energySavingDesc}}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { unwarp } from "@/utils/tools.js";

export default {
  props: ["measureName", "id"],
  setup(props) {
    const measureName = props.measureName;
    const id = props.id;
    return { measureName, id };
  },
  data() {
    return {
      customerId: this.$store.state.customerId,
      dataList: {},
    };
  },
  computed: {
    getDate() {
      return (time) => {
        if (!time) return "暂无数据";
        return time.slice(0, 10);
      };
    },
  },
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
    async getData() {
      try {
        const getTPollutionReducePlanById =
          CONFIG.requestName +
          this.$apiOpt.getTPollutionReducePlanById +
          "/" +
          this.id;
        let res = await this.$apiUtils.get(getTPollutionReducePlanById, {});
        console.log("aaa", res);
        this.dataList = res || {};
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.progressDetailPage {
  // width: 75%;
  ._boxTitle {
    line-height: 80px;
  }
  .yellowLine {
    width: 350px;
    height: 3px;
    background: #ffad25;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.5);
    border-radius: 2px 2px 0px 0px;
    margin: 0 auto;
  }
  ._innerBox {
    width: 1040px;
    height: 753px;
    background: linear-gradient(
      180deg,
      rgba(108, 151, 255, 0.2) 0%,
      rgba(107, 151, 255, 0.2) 48%,
      rgba(58, 116, 255, 0.1) 100%,
      #0049fa 100%,
      #0049fa 100%
    );
    border: 1px solid #8badff;
    margin: 50px auto 0;
    padding: 20px 40px;
    & > ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 20px 0;
      li {
        width: 460px;
        height: 50px;
        background: linear-gradient(
          225deg,
          rgba(108, 151, 255, 0.2) 0%,
          rgba(58, 116, 255, 0.1) 100%,
          #0049fa 100%
        );
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
        border-radius: 2px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        align-items: center;
        .li_left {
          font-size: 18px;
          font-weight: 500;
          color: #f5a623;
        }
        .li_right {
          font-size: 18px;
          font-weight: 500;
          color: #c8d8ff;
          span {
            font-size: 28px;
            font-weight: 500;
            color: #7ff4b1;
            margin-right: 20px;
          }
        }
      }
    }
    .text_box {
      margin: 30px 0 40px;
      width: 960px;
      // height: 180px;
      background: #000000;
      border-radius: 8px;
      border: 1px solid #8ec2ff;
      padding: 18px 20px 8px;
      height: 180px;
      overflow: auto;
      & > p {
        font-size: 16px;
        font-weight: 500;
        color: #c8d8ff;
        line-height: 22px;
      }
    }
  }
}
</style>